module.exports = __webpack_public_path__ + "assets/battery-black.c6e717a0.svg";